<template>
  <div class="text-center custom-select-box">
    <v-menu offset-y :left="true" content-class="bg-white">
      <template v-slot:activator="{ attrs, on }">
        <v-text-field
          class="position-relative custom-select-box__input"
          :class="classList"
          :label="label"
          dense
          outlined
          :required="required ? true : false"
          :rules="rules"
          :append-icon="searchable ? 'mdi-file-find' : ''"
          :placeholder="searchable ? 'جست و جو کنید' : ''"
          v-model="inputValue"
          @keydown="searchItem($event)"
          @focus="focus"
          v-bind="attrs"
          hide-details="auto"
          clearable
          @click:clear="clearInput"
          v-on="on"
        ></v-text-field>
      </template>

      <b-table
        striped
        sticky-header
        style="max-height: 200px"
        :items="itemsList"
        :fields="fields"
        class="max-h-300 custom-select-box__options"
        outlined
        selectable
        ref="customSelectTable"
        :select-mode="'single'"
        @row-selected="onRowSelected"
        responsive
        show-empty
      >
        <template #empty="scope">
          <span>هیچ موردی وجود ندارد </span>
        </template>
        <template #cell(index)="item">
          {{ item.index + 1 }}
        </template>
        <template
          v-for="(_, slotName) of $scopedSlots"
          v-slot:[slotName]="scope"
        >
          <slot :name="slotName" v-bind="scope" />
        </template>
        <template #cell(actions)="item">
          <!-- <v-icon @click="editItem(item)" class="mx-1 text-info" small>
            mdi-pencil
          </v-icon> -->
          <a
            @click.prevent="editItem(item)"
            style="width: 26px; height: 23px"
            class="btn btn-sm btn-clean btn-icon"
            title="ویرایش"
          >
            <i class="la la-edit"></i>
          </a>
        </template>
      </b-table>

      <v-card-actions class="bg-white" v-if="hasAction">
        <v-spacer></v-spacer>

        <div class="d-flex justify-content-center" v-if="pagination">
          <v-tooltip bottom v-if="!hideArrow">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="blue "
                class="show-more__animate"
                @click.stop.prevent="getItems"
              >
                mdi mdi-chevron-down
              </v-icon>
            </template>
            <span>نتایج بیشتر</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="blue"
                @click.stop.prevent="resetItems"
              >
                mdi mdi-chevron-up
              </v-icon>
            </template>
            <span>بازگشت به نتایج کمتر</span>
          </v-tooltip>
        </div>
        <div
          class="text-right d-flex position-relative bg-white mr-2"
          v-if="addable"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="blue"
                v-bind="attrs"
                v-on="on"
                @click.stop.prevent="createItem"
              >
                <v-icon class="transition">mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>جدید</span>
          </v-tooltip>
        </div>
      </v-card-actions>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'CustomSelectBox',
  props: {
    items: {
      type: Array,
      default: [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    classList: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: [],
    },

    searchable: {
      type: Boolean,
      default: true,
    },
    addable: {
      type: Boolean,
      default: true,
    },
    hasAction: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: [Boolean, String],
      default: true,
    },
    itemTitle: {
      type: String,
      default: 'title',
    },
  },

  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 4,
      searching: false,
      showChervonIcon: true,
      hideArrow: false,
      itemsList: [],
      limitedOptions: [],
      option: null,
      selectedItem: null,
      inputValue: null,
    };
  },
  watch: {
    items(after) {
      //  (after);
      if (after) {
        if (!after.length) {
          this.hideArrow = true;
        } else {
          this.itemsList.push(...after);
          if (after.length < this.itemsPerPage) {
            this.showChervonIcon = false;
          }
        }
      }
    },

    value(after) {
      if (after) {
        this.inputValue = after[this.itemTitle];
      } else {
        try {
          this.inputValue = null;
          this.$refs.customSelectTable.clearSelected();
        } catch (error) {}
      }
    },
  },

  mounted() {
    if (this.value) {
      this.inputValue = this.value[this.itemTitle];
    }
    this.$emit('getItems', this.pageNumber, this.itemsPerPage);
  },

  methods: {
    focus() {
      this.$emit('focus');
    },
    clearInput() {
      this.selectedItem = null;
      this.$emit('input', null);
      this.$emit('clear');
      this.$refs.customSelectTable.clearSelected();
    },
    onRowSelected(item) {
      if (item.length) {
        this.$emit('input', item[0]);
        this.$emit('select', item[0]);
        this.selectedItem = item[0];
        this.inputValue = item[0][this.itemTitle];
      } else {
        this.inputValue = null;
        this.selectedItem = null;
        this.$emit('input', null);
        this.$emit('clear');
      }
    },
    closeSelectBox() {
      this.resetItems();
      this.showList = false;
    },
    showLabel(item) {
      return item.length > 15 ? item.slice(0, 15) + '...' : item;
    },
    editItem(item) {
      this.$emit('editItem', item);
    },
    createItem() {
      this.$emit('createItem');
    },

    searchItem(event) {
      if (!this.searchable) {
        event.preventDefault();
        return;
      }
      if (this.searching) {
        clearTimeout(this.searching);
      }
      this.searching = setTimeout(() => {
        this.searching = true;
        if (this.inputValue.length == 0) {
          this.resetItems();
        } else {
          this.itemsList = [];
          this.$emit('searchItem', this.inputValue);
        }
      }, 600);
    },

    resetItems() {
      let $vm = this;
      $vm.pageNumber = 1;
      $vm.itemsList = [];
      $vm.$emit('getItems', $vm.pageNumber, $vm.itemsPerPage);
      $vm.hideArrow = false;
    },
    getItems() {
      this.pageNumber += 1;
      this.$emit('getItems', this.pageNumber, this.itemsPerPage);
    },
    selectItem(option) {
      this.$emit('select', option);
    },
    clearList() {
      this.itemsList = [];
    },
    translate(en) {
      const Fa = {
        NotReceived: 'دریافت نشده',
        Received: 'دریافت شده',
        Receiving: 'درحال دریافت',
        NoFoundation: 'بدون مبنا',
        entryPermit: 'مجوز ورود',
        exitPermit: 'مجوز خروج',
        ReserveInWarehouse: 'رزرو در انبار',
        RequestFromWarehouse: 'درخواست از انبار',
        TemporaryDocument: 'سند موقت',
        Buy: 'خرید',
        Production: 'تولید',
        Consumption: 'مصرف',
        Wastage: 'خرید',
        TransferBetweenWarehouse: 'انتقال',
        WarehouseHandling: 'انبار گردانی',
        Amani: 'امانی',
        Other: 'دیگر',
      };

      return Fa[en];
    },
  },
};
</script>

<style lang="scss">
.max-h-300 {
  max-height: 300px;
}
.custom-select-box {
  ::placeholder {
    font-size: 0.7em;
  }
  .custom-select-box__options {
    margin: 0;
    background: white !important;
    & .b-table > tbody > .table-active,
    & .b-table > tbody > .table-active > th,
    & .b-table > tbody > .table-active > td {
      background-color: rgba(0, 138, 99, 0.95) !important;
      color: white;
    }
  }

  .custom-select-box__input .v-text-field__details {
    position: absolute;
    top: 100%;
  }
  .v-card__actions {
    background: white !important;
  }
}
</style>
